import api from './api';

const procurementServiceMasterService = {
  // Get all procurement services
  getAllProcurementServices: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.serviceType) queryParams.append('serviceType', params.serviceType);
      if (params.category) queryParams.append('category', params.category);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/procurement-service-master${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching procurement services:', error);
      throw error;
    }
  },

  // Get procurement service by ID
  getProcurementServiceById: async (id) => {
    try {
      const response = await api.get(`/procurement-service-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching procurement service:', error);
      throw error;
    }
  },

  // Get next service code
  getNextServiceCode: async () => {
    try {
      const response = await api.get('/procurement-service-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next service code:', error);
      throw error;
    }
  },

  // Create procurement service
  createProcurementService: async (serviceData) => {
    try {
      const response = await api.post('/procurement-service-master', serviceData);
      return response.data;
    } catch (error) {
      console.error('Error creating procurement service:', error);
      throw error;
    }
  },

  // Update procurement service
  updateProcurementService: async (id, serviceData) => {
    try {
      const response = await api.put(`/procurement-service-master/${id}`, serviceData);
      return response.data;
    } catch (error) {
      console.error('Error updating procurement service:', error);
      throw error;
    }
  },

  // Delete procurement service
  deleteProcurementService: async (id) => {
    try {
      const response = await api.delete(`/procurement-service-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting procurement service:', error);
      throw error;
    }
  },

  // Get procurement service statistics
  getProcurementServiceStats: async () => {
    try {
      const response = await api.get('/procurement-service-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching procurement service statistics:', error);
      throw error;
    }
  }
};

export default procurementServiceMasterService;

